export default class Pedido {
  constructor(
    id_empresa = 1,
    id_saida = null,
    id_colaborador = null,
    numero_saida = '',
    id_cliente = null,
    id_cliente_interno = null,
    cliente = 'INFORME O CLIENTE',
    razao_social = 'INFORME O CLIENTE',
    nome_fantasia = 'INFORME O CLIENTE',
    data_emissao = new Date().toISOString().substr(0, 10),
    id_condicao_pagamento = 0,
    condicao_pagamento = 'PERSONALIZADA',
    id_tabela_preco = null,
    tabela_preco = '',
    status = 'O',
    total_bruto = 0,
    total_produto = 0,
    total_desconto = 0,
    itens = [],
    parcelas = [],
    observacoes = '',
    versao_imp = 0
  ) {
    this.id_empresa = id_empresa;
    this.id_saida = id_saida;
    this.id_colaborador = id_colaborador;
    this.numero_saida = numero_saida;
    this.id_cliente = id_cliente;
    this.id_cliente_interno = id_cliente_interno;
    this.cliente = cliente || nome_fantasia;
    this.razao_social = razao_social;
    this.nome_fantasia = nome_fantasia;
    this.data_emissao = data_emissao;
    this.id_condicao_pagamento = id_condicao_pagamento;
    this.condicao_pagamento = condicao_pagamento;
    this.id_tabela_preco = id_tabela_preco;
    this.tabela_preco = tabela_preco;
    this.status = status;
    this.total_bruto = total_bruto;
    this.total_produto = total_produto;
    this.total_desconto = total_desconto;
    this.itens = itens;
    this.parcelas = parcelas;
    this.observacoes = observacoes;
    this.versao_imp = versao_imp;
  }
}